import { ProductKey } from "src/config/config";
import { getMyServiceList } from "src/service/console";
import {
  applyCheckPromotionCode,
  checkPromotionTrial,
  getCashUserStatus,
  getServiceUnregisterBill,
} from "src/service/pay";

const checkProductAvailable = async ({
  product,
}: {
  product: ProductKey;
}): Promise<boolean> => {
  const checkCashStatus = await getCashUserStatus({
    product: [product],
  });
  if (
    (checkCashStatus && checkCashStatus.status === "WAIT") ||
    (checkCashStatus.serviceUid === "" && checkCashStatus.status === "APPLY") ||
    checkCashStatus.status === "APPROVED"
  ) {
    return true;
  } else {
    const serviceList = await getMyServiceList({ product });
    if (
      serviceList === undefined ||
      serviceList === null ||
      serviceList.length === 0
    ) {
      try {
        const unregisterPay = await getServiceUnregisterBill({
          billType: "PAY",
          product,
        });
        const unregisterPromotion = await getServiceUnregisterBill({
          billType: "PROMOTION",
          product,
        });
        if (unregisterPay.length > 0) return true;
        else if (unregisterPromotion.length > 0) return true;
        else {
          const result = await applyCheckPromotionCode({ product });
          if (result) {
            return true;
          } else {
            // 프리미엄 코드가 없으면 체험(trial) 가능 여부로 판정 (반환 형태가 다르므로 변수 분리)
            const trialResult = await checkPromotionTrial({ product });
            return trialResult.status === "IMPOSSIBLE" ||
              trialResult.status === "POSSIBLE" ||
              trialResult.status === "EXIST" ||
              trialResult.status === "T_USED"
              ? false
              : true;
          }
        }
      } catch (err) {
        return false;
      }
    }
  }
  return true;
};

export default checkProductAvailable;
